/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { Component, ViewChild, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "@app/@core/services";
import { SessionStorageService } from "@app/@core/services/session-storage";

@Component({
  selector: "app-setup-google2fa",
  templateUrl: "./setup-google2fa.component.html",
  styleUrls: ["./setup-google2fa.component.scss"],
})
export class SetupGoogle2FAComponent implements AfterViewInit {
  step: number = 1;
  steps_desc: string = "";
  qr = null;

  otp: String = "";
  otp_length: number = 6;
  valid: boolean = false;
  processing: boolean = false;
  code_checked: boolean = false;
  code_verified: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionStorageService: SessionStorageService
  ) {
    this.authService.clear2fa();
    this.sessionStorageService.removeItem("google-2fa");
  }

  ngAfterViewInit(){
    this.authService.generateGoogle2FA().then(res => {
      if (res["error"] === false) {
        this.qr = res["code"];
      } else {
        this.authService.invalidate();
      }
    });
  }

  complete() {
    this.router.navigate(["/"]);
  }

  submit() {
    this.processing = true;
    this.authService.setupGoogle2FA(this.otp).then((res) => {
      if (res["error"] === false && res['check'] === true) {
        this.code_verified = true;
      } else {
        if (res["message"] && res["message"].includes("unauthenticated_user")) {
          this.authService.invalidate();
        } else {
          this.code_verified = false;
        }
      }

      this.code_checked = true;
      this.processing = false;
    });
  }

  otpChanged(evt) {
    this.code_checked = false;
    this.code_verified = false;

    if (evt !== this.otp) {
      this.otp = evt;
      this.processing = false;
      this.valid = this.otp_length == evt.length;

      if (this.valid) this.submit();
    }
  }
}
